import AmexIcon from './AmexIcon'
import ApplePayIcon from './ApplePayIcon'
import DinersClubIcon from './DinersClubIcon'
import DiscoverIcon from './DiscoverIcon'
import GooglePayIcon from './GooglePayIcon'
import JCBIcon from './JCBIcon'
import MaestroIcon from './MaestroIcon'
import MastercardIcon from './MastercardIcon'
import VisaIcon from './VisaIcon'

export {
  AmexIcon,
  VisaIcon,
  MastercardIcon,
  MaestroIcon,
  JCBIcon,
  GooglePayIcon,
  DiscoverIcon,
  DinersClubIcon,
  ApplePayIcon,
}

export const cardBrandIconsMap = {
  VISA: <VisaIcon />,
  MC: <MastercardIcon />,
  DISC: <DiscoverIcon />,
  AMEX: <AmexIcon />,
  MAESTRO: <MaestroIcon />,
  JCB: <JCBIcon />,
  GOOGLEPAY: <GooglePayIcon />,
  APPLEPAY: <ApplePayIcon />,
  DINERSCLUB: <DinersClubIcon />,
}
